const release = ""

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}
const apiClientBaseURL = "/api/"

module.exports = {
    release,
    apiClientBaseURL,
}
